/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I calculate a percentage of a number?`)
};

const es_pct_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo calculo el porcentaje de un número?`)
};

const de_pct_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie berechne ich einen Prozentsatz einer Zahl?`)
};

const nl_pct_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe bereken ik een percentage van een getal?`)
};

const fr_pct_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment calculer un pourcentage d'un nombre ?`)
};

const it_pct_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come calcolo la percentuale di un numero?`)
};

const pt_br2_pct_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como calculo a porcentagem de um número?`)
};

const pt_pct_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como calculo a percentagem de um número?`)
};

const ja_pct_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ある数のパーセントを計算するには？`)
};

const zh_pct_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如何计算一个数的百分比？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_hub_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_hub_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_hub_faq1_q", locale)
	if (locale === "en") return en_pct_hub_faq1_q(inputs)
	if (locale === "es") return es_pct_hub_faq1_q(inputs)
	if (locale === "de") return de_pct_hub_faq1_q(inputs)
	if (locale === "nl") return nl_pct_hub_faq1_q(inputs)
	if (locale === "fr") return fr_pct_hub_faq1_q(inputs)
	if (locale === "it") return it_pct_hub_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_pct_hub_faq1_q(inputs)
	if (locale === "pt") return pt_pct_hub_faq1_q(inputs)
	if (locale === "ja") return ja_pct_hub_faq1_q(inputs)
	return zh_pct_hub_faq1_q(inputs)
};